var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12074_9190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1004 19.7V14.9C10.1004 11.0809 11.6175 7.41819 14.3181 4.71766C17.0186 2.01714 20.6813 0.5 24.5004 0.5C28.3195 0.5 31.9822 2.01714 34.6827 4.71766C37.3833 7.41819 38.9004 11.0809 38.9004 14.9V19.7H41.3004C42.5734 19.7 43.7943 20.2057 44.6945 21.1059C45.5947 22.0061 46.1004 23.227 46.1004 24.5V43.7C46.1004 44.973 45.5947 46.1939 44.6945 47.0941C43.7943 47.9943 42.5734 48.5 41.3004 48.5H7.70039C6.42735 48.5 5.20645 47.9943 4.30628 47.0941C3.4061 46.1939 2.90039 44.973 2.90039 43.7V24.5C2.90039 21.86 5.06039 19.7 7.70039 19.7H10.1004ZM22.1004 35.852V41.3H26.9004V35.852C27.8155 35.3237 28.5307 34.5082 28.935 33.532C29.3394 32.5557 29.4103 31.4734 29.1368 30.4527C28.8634 29.4321 28.2607 28.5302 27.4224 27.887C26.5842 27.2437 25.557 26.8951 24.5004 26.8951C23.4437 26.8951 22.4166 27.2437 21.5783 27.887C20.74 28.5302 20.1374 29.4321 19.8639 30.4527C19.5905 31.4734 19.6614 32.5557 20.0658 33.532C20.4701 34.5082 21.1853 35.3237 22.1004 35.852ZM17.3004 14.9V19.7H31.7004V14.9C31.7004 12.9904 30.9418 11.1591 29.5916 9.80883C28.2413 8.45857 26.41 7.7 24.5004 7.7C22.5908 7.7 20.7595 8.45857 19.4092 9.80883C18.059 11.1591 17.3004 12.9904 17.3004 14.9Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12074_9190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.35af185afcca82ffac497e1ebbb34b14.svg";
export { ForwardRef as ReactComponent };